import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VConsole from 'vconsole'
import {
    server
} from './providers/http-service'
import weui from 'weui.js'
import 'weui'
import util from './utils/util.js'
import animated from 'animate.css'
import './styles/common.less';
import global_ from './config/global.js'
import Exif from 'exif-js'
import 'exif'
Vue.use(animated)
Vue.use(Exif)
Vue.prototype.$Exif = Exif;
//定义全局变量
Vue.prototype.$server = server;
Vue.prototype.$weui = weui;
Vue.prototype.$util = util;
Vue.prototype.GLOBAL = global_;
Vue.config.productionTip = false

/**
 * production/development
 */

if (process.env.NODE_ENV === 'development') {
    let vConsole = new VConsole();
    Vue.use(vConsole)
}

new Vue({
    router,
    store,
    render: h => h(App),

}).$mount('#app')